<template>
  <div class="common-line" style="z-index: 666">
    <div v-resize="resizeChart" :id="lineId" :style="{width: width, height: height}"></div>
  </div>
</template>

<script>
import {debounce} from "../../../utils/util"
export default {
  name: 'common-line',
  props: {
    lineId: {
      type: String,
      default () {
        return 'commonLineId'
      }
    },
    width: {
      type: String,
      default () {
        return '100%'
      }
    },
    height: {
      type: String,
      default () {
        return '240px'
      }
    },
    lineTitle: {
      type: String,
      default () {
        return ''
      }
    },
    titleStyle: {
      type: Object,
      default () {
        return  {}
      }
    },
    legendTextStyle: {
      type: Object,
      default () {
        return  {}
      }
    },
    legendData: {
      type: Array,
      default () {
        return []
      }
    },
    legendWidth: {
      type: String,
      default () {
        return ''
      }
    },
    legendRight: {
      type: String,
      default () {
        return '4%'
      }
    },
    legendType: {
      type: String,
      default () {
        return 'plain'
      }
    },
    legendTop: {
      type: String,
      default () {
        return '0'
      }
    },
    xAxis: {
      type: Object,
      default () {
        return  {}
      }
    },
    yAxis: {
      type: Array,
      default () {
        return []
      }
    },
    series: {
      type: Array,
      default () {
        return []
      }
    },
    titleLeft: {
      type: String,
      default () {
        return '0'
      }
    },
    titleTop: {
      type: String,
      default () {
        return '0'
      }
    },
    gridLeft: {
      type: String,
      default () {
        return '1.7%'
      }
    },
    gridTop: {
      type: String,
      default () {
        return '20%'
      }
    },
  },
  data () {
    return {
      commonLine: null
    }
  },
  mounted () {
    this.drawLine()
    window.addEventListener('resize', this.resizeChart)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.resizeChart)
  },
  directives:{
    resize: { // 指令的名称
      bind(el, binding) { // el为绑定的元素，binding为绑定给指令的对象
        let width = '', height = '';
        function isReize() {
          const style = document.defaultView.getComputedStyle(el);
          if (width !== style.width || height !== style.height) {
            binding.value({width:style.width,height:style.height});  // 关键(这传入的是函数,所以执行此函数)
          }
          width = style.width;
          height = style.height;
        }
        el.__vueSetInterval__ = setInterval(isReize, 300);
      },
      unbind(el) {
        clearInterval(el.__vueSetInterval__);
      }
    }
  },
  methods: {
    drawLine() {
      console.log(this.yAxis, this.xAxis, this.series, '11111')
      let _self = this
      this.commonLine = this.$echarts.init(document.getElementById(this.lineId))
      this.commonLine.setOption({
        title: {
          text: this.lineTitle,
          textStyle: this.titleStyle,
          left: this.titleLeft,
          top: this.titleTop,
        },
        tooltip : {
          order: 'seriesDesc',
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#6a7985'
            }
          },
          extraCssText: 'z-index: 9999;',
          className: 'echarts-tooltip'
        },
        legend: {
          icon: "rect",   //  字段控制形状  类型包括 circle，rect,line，roundRect，triangle，diamond，pin，arrow，none
          itemWidth: 10,  // 设置宽度
          itemHeight: 10, // 设置高度
          type: this.legendType,
          right: this.legendRight,
          top: this.legendTop,
          data: this.legendData,
          width: this.legendWidth,
          textStyle: this.legendTextStyle
        },
        // color: ['#92D050', '#FFC000'],
        grid: {
          top: this.gridTop,
          left: this.gridLeft,
          right: '3.2%',
          bottom: '1.3%',
          containLabel: true
        },
        xAxis: this.xAxis,
        yAxis: this.yAxis,
        series: this.series
      },true)
    },
    resizeChart: debounce(function () {
      this.commonLine.resize()
    }, 100)
  },
  watch: {
    series: {
      handler(newValue, oldValue) {
        console.log(newValue, oldValue)
        this.drawLine()
      },
      deep: true
    }
  }
}
</script>

<style scoped>
.common-line {
  width: 100%;
}
</style>
<style lang="less" scoped>
/deep/.echarts-tooltip {
  z-index: 9999; /* 设置一个较高的 z-index 值 */
}
</style>



// WEBPACK FOOTER //
// src/components/Echarts/Line/commonLine.vue